<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group class="basic-group no-header">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name">
                        </wbo-text-edit-control>
                        <wbo-text-edit-control formControlName="code" [(ngModel)]="model.data.code">
                        </wbo-text-edit-control>
                        <wbo-time-edit-control formControlName="startTime" [(ngModel)]="model.data.startTime">
                        </wbo-time-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
